<template>
    <div :class="{selectable: isSelectable}" @click="select()">
        <slot></slot>
    </div>
</template>

<script>
  export default {
    name: "AuditSelectable",
    props: {
      properties: Object,
    },
    computed: {
      isSelectable() {
        return this.$parent.isSelectable(Object.keys(this.properties))
      }
    },
    methods: {
      select() {
        this.$parent.select(this.properties);
      }
    }
  }
</script>